import React from "react";
import SystemContainer from "./SystemContainer";

const System = () => {
  return <SystemContainer />;
};

export default System;
